import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useQuery } from '@tanstack/react-query';
import dayjs from "dayjs";

import InvoiceChart from "../InvoiceChart/InvoiceChart";
import LocationActivityOverview from "../Dashboard/LocationActivityOverview";
import ProjectedInvoice from "../Dashboard/ProjectedInvoice";
import Loading from "../Loading";
import { useVendor } from "../../utils/Context";
import { fetchDashboard } from "../Dashboard/Dashboard";
import ApproachCreditNote from "../Dashboard/ApproachCreditNote";
import { getPermissionByPrefix } from "../../utils/permissions";
import InvoiceListing from "./InvoiceListing";

const InvoiceDashboard = () => {
  const { selectedVendor } = useVendor();
  const { is_view: canViewCredit } = getPermissionByPrefix("credit_achievement");
  const [dateRange] = useState({
    start: dayjs("2024-01-01"),
    end: dayjs(),
  });
  const [selectedLoc] = useState("All");
  const [selectedCountry] = useState("All");

  const stableQueryKey = [
    "dashboard",
    {
      startDate: dateRange.start.format("YYYY-MM-DD"),
      endDate: dateRange.end.format("YYYY-MM-DD"),
      selectedVendor,
      selectedLoc,
      selectedCountry,
    },
  ];

  const {
    data: dashboard,
    isLoading: loadingDashboard,
  } = useQuery({
    queryKey: stableQueryKey,
    queryFn: fetchDashboard,
    retry: false,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });

  const formatNumber = (num) => {
    const value = Number(num);
    if (!Number.isFinite(value)) return "0.00";
    const absValue = Math.abs(value);
    if (absValue >= 1_000_000) return (value / 1_000_000).toFixed(2).replace(/\.?0+$/, "") + "M";
    if (absValue >= 1_000) return (value / 1_000).toFixed(2).replace(/\.?0+$/, "") + "K";
    return value.toFixed(2);
  };

  return (
    <Box sx={{ p: 2, bgcolor: "#f8fafc", minHeight: "100vh", width: "100%", boxSizing: "border-box" }}>
      {loadingDashboard ? (
        <Loading />
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <InvoiceChart />
          
          <InvoiceListing />
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', alignItems: 'start' }}>
            <ProjectedInvoice 
              dashboardData={dashboard || {}} 
              formatCurrency={formatNumber} 
            />
            <LocationActivityOverview />
          </div>

          {canViewCredit && (
            <Box>
              <ApproachCreditNote />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default InvoiceDashboard;
